// eslint-disable-next-line import/prefer-default-export
export const DetailsType = {
  Model: 'model',
  Light: 'light',
  Interior: 'interior',
  Scene: 'scene',
};
